import script from "./ChangeResult.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeResult.vue?vue&type=script&setup=true&lang=js"

import "./ChangeResult.vue?vue&type=style&index=0&id=10ff90dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10ff90dc"]])

export default __exports__